function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 14,
  r: 14
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#F3F5F7",
  d: "M6.2 21.8C4.1 19.7 3 16.9 3 14.2L13.9 25c-2.8-.1-5.6-1.1-7.7-3.2zm10.2 2.9L3.3 11.6C4.4 6.7 8.8 3 14 3c3.7 0 6.9 1.8 8.9 4.5l-1.5 1.3C19.7 6.5 17 5 14 5c-3.9 0-7.2 2.5-8.5 6L17 22.5c2.9-1 5.1-3.5 5.8-6.5H18v-2h7c0 5.2-3.7 9.6-8.6 10.7z"
});

function SvgGatsby(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    focusable: "false"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyOCAyOCIgZm9jdXNhYmxlPSJmYWxzZSI+CiAgPGNpcmNsZSBjeD0iMTQiIGN5PSIxNCIgcj0iMTQiIC8+CiAgPHBhdGggZmlsbD0iI0YzRjVGNyIgZD0iTTYuMiAyMS44QzQuMSAxOS43IDMgMTYuOSAzIDE0LjJMMTMuOSAyNWMtMi44LS4xLTUuNi0xLjEtNy43LTMuMnptMTAuMiAyLjlMMy4zIDExLjZDNC40IDYuNyA4LjggMyAxNCAzYzMuNyAwIDYuOSAxLjggOC45IDQuNWwtMS41IDEuM0MxOS43IDYuNSAxNyA1IDE0IDVjLTMuOSAwLTcuMiAyLjUtOC41IDZMMTcgMjIuNWMyLjktMSA1LjEtMy41IDUuOC02LjVIMTh2LTJoN2MwIDUuMi0zLjcgOS42LTguNiAxMC43eiIvPgo8L3N2Zz4K";
export { SvgGatsby as ReactComponent };